import { TextField, TextFieldProps } from "@mui/material";


export type EmailFieldProps = TextFieldProps;


export default function EmailField({ ...props }: EmailFieldProps) {
    return <TextField type="email" placeholder="someone@gmail.com" {...props} />
}